import { ILocationConfig, TLocationName } from "./location.t";
import { BREAKPOINTS } from "../../app/appConstants";
import { MobileRouterPaths } from "../../mobileAppCore/mobileAppConstants";
import { SIDE_MENU_IDS } from "../SideMenu/sideMenuConstants";
import { MODALS_NAME } from "../Modals/modalsConstants";
import { MOBILE_SLIDER_PAGES_IDS } from "../../mobileAppCore/components/MobileSliderPages/mobileSliderPagesConstants";

export const LOCATION_PLATFORM = {
    DESKTOP: 'desktop',
    DESKTOP_DX: 'desktop_dx',
    MOBILE: 'mobile',
} as const;

export const DESKTOP_PLATFORM_MIN_WIDTH = BREAKPOINTS.medium;

export const LOCATION_SEARCH_PARAM = 'location';

export const LOCATION_COMPONENTS_SEARCH_PARAMS = {
    SIDE_MENU: 'sm',
    SLIDE: 's',
    MODAL: 'm',
    TAB: 'tab'
} as const;

export const LOCATION_NAMES = {
    ACADEMY: 'academy',
    ACADEMY_COURSE: 'academy-course',
    ACADEMY_LESSON: 'academy-lesson',
    ACHIEVEMENT: 'achievement',
    ADVANCED_SETTINGS: 'advanced-settings',
    ALERTS: 'alerts',
    APPEARANCE: 'appearance',
    ASSET: 'asset',
    BEGINNERS_GUIDE: 'beginners-guide',
    CASHBACK: 'cashback',
    CLIENT_AGREEMENT: 'client-agreement',
    COLLECTION: 'collection',
    CONTACTS: 'contacts',
    DELETE_PROFILE: 'delete-profile',
    DEMO_LIMITS: 'demo-limits',
    DEPOSIT: 'deposit',
    EDIT_ORDER: 'edit-order',
    EDIT_POSITION: 'edit-position',
    EMAIL_CONFIRMED: 'email-confirmed',
    FIRST_START: 'first-start',
    GLORY_ARENA: 'glory-arena',
    HISTORY: 'history',
    HISTORY_INFO: 'history-info',
    LEADERBOARD: 'leaderboard',
    LEADERBOARD_ONBOARDING: 'leaderboard-onboarding',
    LEADERBOARD_NOTIFICATION_LEAGUE: 'leaderboard-notification-league',
    HOME: 'home',
    MARKET: 'market',
    MOBILE_COMMUNITY: 'mobile-community',
    OVERVIEW: 'overview',
    PRIVACY_POLICY: 'privacy-policy',
    PROFILE: 'profile',
    REFERRAL: 'referral',
    REFERRAL_AMAZING: 'referral-amazing',
    REFERRAL_GIFT_REWARD: 'referral-gift-reward',
    REFERRAL_RECEIVED_REWARD: 'referral-received-reward',
    REFERRAL_RESPAWN_TIMER: 'referral-respawn-timer',
    REFERRAL_RULES: 'referral-rules',
    REFERRAL_SHARE_LINK: 'referral-share-link',
    REFERRAL_SHARE_QR_CODE: 'referral-share-qr-code',
    REFERRAL_WARNING_RESET_PROGRESS: 'referral-warning-reset-progress',
    REFILL: 'refill',
    REQUEST_FEEDBACK: 'request-feedback',
    RESPAWN: 'respawn',
    RESPAWN_MOTIVATION: 'respawn_motivation',
    RESPAWN_STATUS: 'respawn-status',
    SETTINGS: 'settings',
    STATUS_CONGRATULATIONS: 'status-congratulations',
    TUTORIALS: 'tutorials',
    TUTORIAL_VIDEO: 'tutorial-video',
    USER_STATE_INFORMATION: 'user-state-information',
    USER_STATUSES: 'user-statuses',
    VERIFY: 'verify',
    VERIFY_MANUAL: 'verify-manual',
    VERIFY_REQUEST: 'verify-request',
    VERIFY_SUMSUB: 'verify-sumsub',
    WITHDRAW: 'withdraw',
    WITHDRAWAL_CANCEL: 'withdrawal-cancel',
    WITHDRAWAL_LIMITS: 'withdrawal-limits',
} as const;

export const LOCATION_CONFIGS: { [name in TLocationName]: ILocationConfig } = {
    [LOCATION_NAMES.ACADEMY]: {
        desktop: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SIDE_MENU}=${SIDE_MENU_IDS.ACADEMY}` },
        mobile: { pathname: MobileRouterPaths.academy, exact: true },
    },
    [LOCATION_NAMES.ACADEMY_COURSE]: {
        desktop: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SIDE_MENU}=${SIDE_MENU_IDS.ACADEMY_COURSE}` },
        mobile: {
            pathname: MobileRouterPaths.academy,
            search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE}=${MOBILE_SLIDER_PAGES_IDS.ACADEMY_COURSE}`,
        },
    },
    [LOCATION_NAMES.ACADEMY_LESSON]: {
        desktop: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SIDE_MENU}=${SIDE_MENU_IDS.ACADEMY_LESSON}` },
        mobile: {
            pathname: MobileRouterPaths.academy,
            search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE}=${MOBILE_SLIDER_PAGES_IDS.ACADEMY_LESSON}`,
        },
    },
    [LOCATION_NAMES.ALERTS]: {
        desktop: {
            pathname: MobileRouterPaths.default,
            search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.MODAL}=alerts` // TODO CFD-7626: Временная заглушка, скорректировать после реализации макета alerts для десктопа
        },
        mobile: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE}=${MOBILE_SLIDER_PAGES_IDS.ALERTS}` },
    },
    [LOCATION_NAMES.CONTACTS]: { pathname: MobileRouterPaths.contacts },
    [LOCATION_NAMES.HOME]: {
        desktop: { pathname: MobileRouterPaths.default, exact: true },
        mobile: { pathname: MobileRouterPaths.portfolio, exact: true },
    },
    [LOCATION_NAMES.MARKET]: {
        desktop: {
            pathname: MobileRouterPaths.default,
            search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SIDE_MENU}=${SIDE_MENU_IDS.MARKET}`
        },
        desktop_dx: { pathname: MobileRouterPaths.default },
        mobile: { pathname: MobileRouterPaths.market },
    },
    [LOCATION_NAMES.PROFILE]: {
        desktop: {
            pathname: MobileRouterPaths.default,
            search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SIDE_MENU}=${SIDE_MENU_IDS.PROFILE}`
        },
        mobile: { pathname: MobileRouterPaths.profile },
    },
    [LOCATION_NAMES.WITHDRAW]: {
        desktop: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.MODAL}=${MODALS_NAME.CASHIER}&tab=withdraw` },
        desktop_dx: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.MODAL}=${MODALS_NAME.CASHIER}&tab=withdraw` },
        mobile: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE}=${MOBILE_SLIDER_PAGES_IDS.WITHDRAW}` },
    },
    [LOCATION_NAMES.ASSET]: {
        desktop: { search: `asset=true` },
        mobile: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE}=${MOBILE_SLIDER_PAGES_IDS.ASSET}` },
    },
    [LOCATION_NAMES.RESPAWN]: {
        desktop: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.MODAL}=${MODALS_NAME.RESPAWN}` },
        mobile: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE}=${MOBILE_SLIDER_PAGES_IDS.RESPAWN}` },
    },
    [LOCATION_NAMES.RESPAWN_STATUS]: {
        desktop: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SIDE_MENU}=${SIDE_MENU_IDS.USER_STATUSES}&${LOCATION_COMPONENTS_SEARCH_PARAMS.MODAL}=${MODALS_NAME.RESPAWN_STATUS}` },
        mobile: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE}=${MOBILE_SLIDER_PAGES_IDS.USER_STATUSES}&widget=respawn` },
    },
    [LOCATION_NAMES.CASHBACK]: {
        desktop: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SIDE_MENU}=${SIDE_MENU_IDS.USER_STATUSES}&${LOCATION_COMPONENTS_SEARCH_PARAMS.MODAL}=${MODALS_NAME.CASHBACK}` },
        mobile: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE}=${MOBILE_SLIDER_PAGES_IDS.USER_STATUSES}&widget=cashback` },
    },
    [LOCATION_NAMES.DEPOSIT]: {
        desktop: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.MODAL}=${MODALS_NAME.CASHIER}&tab=deposit` },
        desktop_dx: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.MODAL}=${MODALS_NAME.CASHIER}&tab=deposit` },
        mobile: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE}=${MOBILE_SLIDER_PAGES_IDS.DEPOSIT}` },
    },
    [LOCATION_NAMES.VERIFY]: {
        desktop: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SIDE_MENU}=${SIDE_MENU_IDS.VERIFY}` },
        mobile: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE}=${MOBILE_SLIDER_PAGES_IDS.VERIFY}` },
    },
    [LOCATION_NAMES.REFERRAL]: {
        // TODO: CFD-7163: Доработать открытие страницы рефералов для десктопа
        desktop: {
            pathname: MobileRouterPaths.default,
            search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SIDE_MENU}=${SIDE_MENU_IDS.REFERRAL}`
        },
        mobile: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE}=${MOBILE_SLIDER_PAGES_IDS.REFERRAL}` },
    },
    [LOCATION_NAMES.REFILL]: {
        desktop: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.MODAL}=${MODALS_NAME.REFILL}` },
        mobile: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE}=${MOBILE_SLIDER_PAGES_IDS.REFILL}` },
    },
    [LOCATION_NAMES.USER_STATUSES]: {
        desktop: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SIDE_MENU}=${SIDE_MENU_IDS.USER_STATUSES}` },
        desktop_dx: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.MODAL}=${MODALS_NAME.USER_STATUSES}` },
        mobile: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE}=${MOBILE_SLIDER_PAGES_IDS.USER_STATUSES}` },
    },
    [LOCATION_NAMES.WITHDRAWAL_LIMITS]: {
        desktop: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.MODAL}=${MODALS_NAME.WITHDRAWAL_LIMITS}` },
        desktop_dx: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.MODAL}=${MODALS_NAME.WITHDRAWAL_LIMITS}` },
        mobile: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE}=${MOBILE_SLIDER_PAGES_IDS.WITHDRAWAL_LIMITS}` },
    },
    [LOCATION_NAMES.HISTORY]: {
        desktop: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SIDE_MENU}=${SIDE_MENU_IDS.HISTORY}` },
        desktop_dx: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.MODAL}=${MODALS_NAME.CASHIER}&tab=history` },
        mobile: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE}=${MOBILE_SLIDER_PAGES_IDS.HISTORY}` },
    },
    [LOCATION_NAMES.HISTORY_INFO]: {
        desktop: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SIDE_MENU}=${SIDE_MENU_IDS.HISTORY_INFO}` },
        mobile: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE}=${MOBILE_SLIDER_PAGES_IDS.HISTORY_INFO}` },
    },
    [LOCATION_NAMES.EDIT_POSITION]: {
        desktop: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.MODAL}=${MODALS_NAME.POSITION_UPDATE}` },
        mobile: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE}=${MOBILE_SLIDER_PAGES_IDS.POSITION_UPDATE_2}` },
    },
    [LOCATION_NAMES.EDIT_ORDER]: {
        desktop: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.MODAL}=${MODALS_NAME.ORDER_UPDATE}` },
        mobile: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE}=${MOBILE_SLIDER_PAGES_IDS.ORDER_UPDATE_2}` },
    },
    [LOCATION_NAMES.USER_STATE_INFORMATION]: {
        desktop: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.MODAL}=${MODALS_NAME.USER_STATE_INFORMATION}` },
        mobile: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE}=${MOBILE_SLIDER_PAGES_IDS.USER_STATE_INFORMATION}` },
    },
    [LOCATION_NAMES.SETTINGS]: {
        mobile: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE}=${MOBILE_SLIDER_PAGES_IDS.SETTINGS}` },
        desktop: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SIDE_MENU}=${SIDE_MENU_IDS.SETTINGS}` },
    },
    [LOCATION_NAMES.MOBILE_COMMUNITY]: {
        mobile: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE}=${MOBILE_SLIDER_PAGES_IDS.COMMUNITY}` },
        desktop: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SIDE_MENU}=${SIDE_MENU_IDS.MOBILE_COMMUNITY}` },
    },
    [LOCATION_NAMES.GLORY_ARENA]: {
        mobile: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE}=${MOBILE_SLIDER_PAGES_IDS.GLORY_ARENA}` },
        desktop: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SIDE_MENU}=${SIDE_MENU_IDS.GLORY_ARENA}` },
    },
    [LOCATION_NAMES.TUTORIALS]: {
        mobile: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE}=${MOBILE_SLIDER_PAGES_IDS.TUTORIALS}` },
        desktop: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SIDE_MENU}=${SIDE_MENU_IDS.TUTORIALS}` },
    },
    [LOCATION_NAMES.TUTORIAL_VIDEO]: {
        mobile: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE}=${MOBILE_SLIDER_PAGES_IDS.TUTORIAL_VIDEO}` },
        desktop: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SIDE_MENU}=${SIDE_MENU_IDS.TUTORIAL_VIDEO}` },
    },
    [LOCATION_NAMES.COLLECTION]: {
        mobile: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE}=${MOBILE_SLIDER_PAGES_IDS.COLLECTION}` },
        desktop: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SIDE_MENU}=${SIDE_MENU_IDS.COLLECTION}` },
    },
    [LOCATION_NAMES.ACHIEVEMENT]: {
        mobile: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE}=${MOBILE_SLIDER_PAGES_IDS.ACHIEVEMENT}` },
        desktop: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.MODAL}=${MODALS_NAME.ACHIEVEMENT}` },
    },
    [LOCATION_NAMES.STATUS_CONGRATULATIONS]: {
        mobile: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE}=${MOBILE_SLIDER_PAGES_IDS.USER_STATUS_CONGRATULATIONS}` },
        desktop: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.MODAL}=${MODALS_NAME.STATUS_CONGRATULATIONS}` },
    },
    [LOCATION_NAMES.RESPAWN_MOTIVATION]: {
        mobile: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE}=${MOBILE_SLIDER_PAGES_IDS.RESPAWN_MOTIVATION}` },
        desktop: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.MODAL}=${MODALS_NAME.RESPAWN_MOTIVATION}` },
    },
    [LOCATION_NAMES.OVERVIEW]: {
        mobile: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE}=${MOBILE_SLIDER_PAGES_IDS.ACCOUNT_STAT}` },
        desktop: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SIDE_MENU}=${SIDE_MENU_IDS.OVERVIEW}` },
    },
    [LOCATION_NAMES.REQUEST_FEEDBACK]: {
        mobile: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE}=${MOBILE_SLIDER_PAGES_IDS.REQUEST_FEEDBACK}` },
        desktop: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.MODAL}=${MODALS_NAME.REQUEST_FEEDBACK}` },
    },
    [LOCATION_NAMES.FIRST_START]: {
        mobile: { pathname: MobileRouterPaths.firstStart },
        // TODO desktop intro is not implemented yet
    },
    [LOCATION_NAMES.DELETE_PROFILE]: {
        desktop: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.MODAL}=${MODALS_NAME.DELETE_PROFILE}` },
        mobile: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE}=${MOBILE_SLIDER_PAGES_IDS.DELETE_PROFILE}` },
    },
    [LOCATION_NAMES.EMAIL_CONFIRMED]: {
        desktop: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.MODAL}=${MODALS_NAME.EMAIL_CONFIRMED}` },
        mobile: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE}=${MOBILE_SLIDER_PAGES_IDS.EMAIL_CONFIRMED}` },
    },
    [LOCATION_NAMES.WITHDRAWAL_CANCEL]: {
        desktop: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.MODAL}=${MODALS_NAME.WITHDRAWAL_CANCEL}` },
        mobile: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE}=${MOBILE_SLIDER_PAGES_IDS.WITHDRAWAL_CANCEL}` },
    },
    [LOCATION_NAMES.BEGINNERS_GUIDE]: {
        desktop: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SIDE_MENU}=${SIDE_MENU_IDS.TUTORIALS}` },
        mobile: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE}=${MOBILE_SLIDER_PAGES_IDS.BEGINNERS_GUIDE}` },
    },
    [LOCATION_NAMES.PRIVACY_POLICY]: {
        desktop: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SIDE_MENU}=${SIDE_MENU_IDS.PRIVACY_POLICY}` },
        mobile: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE}=${MOBILE_SLIDER_PAGES_IDS.PRIVACY_POLICY}` },
    },
    [LOCATION_NAMES.CLIENT_AGREEMENT]: {
        desktop: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SIDE_MENU}=${SIDE_MENU_IDS.CLIENT_AGREEMENT}` },
        mobile: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE}=${MOBILE_SLIDER_PAGES_IDS.CLIENT_AGREEMENT}` },
    },
    [LOCATION_NAMES.VERIFY_MANUAL]: {
        desktop: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE}=${MOBILE_SLIDER_PAGES_IDS.VERIFY_MANUAL}` },
        mobile: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE}=${MOBILE_SLIDER_PAGES_IDS.VERIFY_MANUAL}` },
    },
    [LOCATION_NAMES.VERIFY_SUMSUB]: {
        desktop: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE}=${MOBILE_SLIDER_PAGES_IDS.VERIFY_SUMSUB}` },
        mobile: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE}=${MOBILE_SLIDER_PAGES_IDS.VERIFY_SUMSUB}` },
    },
    [LOCATION_NAMES.VERIFY_REQUEST]: {
        desktop: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.MODAL}=${MOBILE_SLIDER_PAGES_IDS.VERIFY_REQUEST}` },
        mobile: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE}=${MOBILE_SLIDER_PAGES_IDS.VERIFY_REQUEST}` },
    },
    [LOCATION_NAMES.ADVANCED_SETTINGS]: {
        desktop: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SIDE_MENU}=${SIDE_MENU_IDS.ADVANCED_SETTINGS}` },
        mobile: {
            search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE}=${MOBILE_SLIDER_PAGES_IDS.ADVANCED_SETTINGS}`
        },
    },
    [LOCATION_NAMES.REFERRAL_RULES]: {
        mobile: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE}=${MOBILE_SLIDER_PAGES_IDS.REFERRAL_RULES}` },
        desktop: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SIDE_MENU}=${SIDE_MENU_IDS.REFERRAL_RULES}` },
    },
    [LOCATION_NAMES.REFERRAL_AMAZING]: {
        mobile: { pathname: MobileRouterPaths.referralAmazing },
        desktop: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SIDE_MENU}=${SIDE_MENU_IDS.REFERRAL_AMAZING}` },
    },
    [LOCATION_NAMES.APPEARANCE]: {
        desktop: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SIDE_MENU}=${SIDE_MENU_IDS.APPEARANCE}` },
        mobile: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE}=${MOBILE_SLIDER_PAGES_IDS.APPEARANCE}` },
    },
    [LOCATION_NAMES.REFERRAL_RECEIVED_REWARD]: {
        mobile: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE}=${MOBILE_SLIDER_PAGES_IDS.REFERRAL_RECEIVED_REWARD}` },
        desktop: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.MODAL}=${MODALS_NAME.REFERRAL_RECEIVED_REWARD}` },
    },
    [LOCATION_NAMES.REFERRAL_GIFT_REWARD]: {
        desktop: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.MODAL}=${MODALS_NAME.REFERRAL_GIFT_REWARD}` },
        mobile: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE}=${MOBILE_SLIDER_PAGES_IDS.REFERRAL_GIFT_REWARD}` },
    },
    [LOCATION_NAMES.DEMO_LIMITS]: {
        desktop: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.MODAL}=${MODALS_NAME.DEMO_LIMITS}` },
        mobile: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE}=${MOBILE_SLIDER_PAGES_IDS.DEMO_LIMITS}` },
    },
    [LOCATION_NAMES.REFERRAL_WARNING_RESET_PROGRESS]: {
        desktop: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.MODAL}=${MOBILE_SLIDER_PAGES_IDS.REFERRAL_WARNING_RESET_PROGRESS}` },
        mobile: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE}=${MOBILE_SLIDER_PAGES_IDS.REFERRAL_WARNING_RESET_PROGRESS}` },
    },
    [LOCATION_NAMES.REFERRAL_SHARE_LINK]: {
        desktop: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.MODAL}=${MODALS_NAME.REFERRAL_SHARE_LINK}` },
        mobile: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE}=${MOBILE_SLIDER_PAGES_IDS.REFERRAL_SHARE_LINK}` }
    },
    [LOCATION_NAMES.REFERRAL_SHARE_QR_CODE]: {
        desktop: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.MODAL}=${MODALS_NAME.REFERRAL_SHARE_QR_CODE}` },
        mobile: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE}=${MOBILE_SLIDER_PAGES_IDS.REFERRAL_SHARE_QR_CODE}` }
    },
    [LOCATION_NAMES.REFERRAL_RESPAWN_TIMER]: {
        desktop: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.MODAL}=${MODALS_NAME.REFERRAL_RESPAWN_TIMER}` },
        mobile: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE}=${MOBILE_SLIDER_PAGES_IDS.REFERRAL_RESPAWN_TIMER}` }
    },
    [LOCATION_NAMES.LEADERBOARD]: {
        mobile: { pathname: MobileRouterPaths.leaderboard },
        desktop: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SIDE_MENU}=${SIDE_MENU_IDS.LEADERBOARD}` },
    },
    [LOCATION_NAMES.LEADERBOARD_ONBOARDING]: {
        mobile: { pathname: MobileRouterPaths.leaderboardOnboarding },
        desktop: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SIDE_MENU}=${SIDE_MENU_IDS.LEADERBOARD_ONBOARDING}` },
    },
    [LOCATION_NAMES.LEADERBOARD_NOTIFICATION_LEAGUE]: {
        desktop: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.MODAL}=${MODALS_NAME.LEADERBOARD_NOTIFICATION_LEAGUE}` },
        mobile: { search: `${LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE}=${MOBILE_SLIDER_PAGES_IDS.LEADERBOARD_NOTIFICATION_LEAGUE}` },
    },
} as const;
